import { render, staticRenderFns } from "./Plan_Details.vue?vue&type=template&id=439b3949"
var script = {}
import style0 from "./Plan_Details.vue?vue&type=style&index=0&id=439b3949&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports